/**
 * Positionne un menu flottant (fixed) par rapport à un bouton déclencheur.
 * Bascule au-dessus du bouton si l'espace en bas est insuffisant.
 */
export function computeFloatingMenuPosition(anchorRect, options = {}) {
  const menuWidth = options.menuWidth ?? 220;
  const menuHeight = options.menuHeight ?? 140;
  const gap = options.gap ?? 6;
  const padding = options.padding ?? 12;

  const left = Math.max(
    padding,
    Math.min(anchorRect.right - menuWidth, window.innerWidth - menuWidth - padding)
  );

  const spaceBelow = window.innerHeight - anchorRect.bottom - gap - padding;
  const spaceAbove = anchorRect.top - gap - padding;
  const preferBelow = spaceBelow >= menuHeight || spaceBelow >= spaceAbove;

  let top;
  let placement = 'below';

  if (preferBelow) {
    top = anchorRect.bottom + gap;
    if (top + menuHeight > window.innerHeight - padding) {
      top = Math.max(padding, window.innerHeight - menuHeight - padding);
    }
  } else {
    top = anchorRect.top - menuHeight - gap;
    placement = 'above';
    if (top < padding) {
      top = padding;
    }
  }

  return { top, left, placement };
}

/** Hauteur approximative selon le nombre d'entrées du menu. */
export function estimateActionMenuHeight(itemCount, { withSeparator = false } = {}) {
  const ITEM_HEIGHT = 40;
  const SEPARATOR_HEIGHT = 9;
  const PADDING = 14;
  return PADDING + itemCount * ITEM_HEIGHT + (withSeparator ? SEPARATOR_HEIGHT : 0);
}
